// Beautiful Modern Vivah Logo - Elegant Twin Rings Design
import React from 'react';

export function VivahLogoIcon({ size = 24 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="vivah-logo-icon"
    >
      <defs>
        <linearGradient id="iconGrad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#D4A574" stopOpacity="1" />
          <stop offset="100%" stopColor="#C8716A" stopOpacity="1" />
        </linearGradient>
        <filter id="iconShadow" x="-50%" y="-50%" width="200%" height="200%">
          <feDropShadow dx="0" dy="2" stdDeviation="2" floodOpacity="0.22" />
        </filter>
      </defs>
      <circle cx="24" cy="24" r="18.5" stroke="url(#iconGrad)" strokeWidth="1.2" opacity="0.3" />
      <circle cx="16" cy="24" r="9.5" fill="none" stroke="url(#iconGrad)" strokeWidth="3.2" />
      <circle cx="32" cy="24" r="9.5" fill="none" stroke="url(#iconGrad)" strokeWidth="3.2" />
      <circle cx="24" cy="24" r="3.5" fill="url(#iconGrad)" filter="url(#iconShadow)" />
      <circle cx="24" cy="6" r="2.2" fill="url(#iconGrad)" opacity="0.95" />
    </svg>
  );
}

export default function VivahLogo() {
  return (
    <svg
      width="180"
      height="56"
      viewBox="0 0 180 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="vivah-logo"
    >
      <defs>
        <linearGradient id="premiumGrad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#D4A574" stopOpacity="1" />
          <stop offset="100%" stopColor="#C8716A" stopOpacity="1" />
        </linearGradient>
        <filter id="premiumShadow" x="-50%" y="-50%" width="200%" height="200%">
          <feDropShadow dx="0" dy="3" stdDeviation="3" floodOpacity="0.25" />
        </filter>
      </defs>

      {/* Outer elegant ring - increased padding */}
      <circle cx="28" cy="28" r="22" stroke="url(#premiumGrad)" strokeWidth="1.5" opacity="0.35" />

      {/* Left ring - Bride - increased size */}
      <circle cx="18" cy="28" r="11" fill="none" stroke="url(#premiumGrad)" strokeWidth="3.5" />

      {/* Right ring - Groom - increased size */}
      <circle cx="38" cy="28" r="11" fill="none" stroke="url(#premiumGrad)" strokeWidth="3.5" />

      {/* Center diamond/union */}
      <circle cx="28" cy="28" r="4" fill="url(#premiumGrad)" filter="url(#premiumShadow)" />

      {/* Top accent */}
      <circle cx="28" cy="4" r="2.5" fill="url(#premiumGrad)" opacity="0.95" />

      {/* Delicate connecting line */}
      <line x1="28" y1="6.5" x2="28" y2="15" stroke="url(#premiumGrad)" strokeWidth="1.8" opacity="0.45" />

      {/* Text: Vivah */}
      <text
        x="58"
        y="35"
        fontFamily="'Cormorant Garamond', 'Georgia', serif"
        fontSize="36"
        fontWeight="700"
        fill="url(#premiumGrad)"
        letterSpacing="4"
      >
        Vivah
      </text>

      {/* Decorative dots */}
      <circle cx="62" cy="46" r="1.2" fill="url(#premiumGrad)" opacity="0.7" />
      <circle cx="73" cy="46" r="1.2" fill="url(#premiumGrad)" opacity="0.7" />
      <circle cx="84" cy="46" r="1.2" fill="url(#premiumGrad)" opacity="0.7" />
    </svg>
  );
}
